import { useMarketStore } from '@/store/use-markets-store';
import { bigIntToNum, formatBigInt } from '@/utils/value-format';
import { ColumnDef } from '@tanstack/react-table';
import { useStore } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

type Props = {
  symbol: string;
};

export default function IndexPrice({ symbol }: Props) {
  const { indexPrice, priceDecimals } = useStore(
    useMarketStore(symbol),
    useShallow((state) => ({
      indexPrice: state.marketData.indexPrice,
      priceDecimals: state.marketSpec.priceDecimals,
    })),
  );
  return formatBigInt(indexPrice, priceDecimals, {
    style: 'currency',
    digits: Number(priceDecimals),
  });
}

export const indexPriceAccessorFn = (symbol: string) => {
  const {
    marketData: { indexPrice },
    marketSpec: { priceDecimals },
  } = useMarketStore(symbol).getState();
  return bigIntToNum(indexPrice, priceDecimals);
};
